import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';

import lines from './lines'
import linesIds from './linesIds'
import title from './title'
import dropBox from './dropBox'
import tags from './tags'
import tagsIds from './tagsIds'
import tagColors from './tagColors'
import openComments from './openComments'
import notificCommentIds from './notificCommentIds'
import favicon from './favicon'
import userName from './userName'
import user from './user'
import filterTagIds from './filterTagIds'
import commentsTime from './commentsTime'
import rangy from './rangy'
import savedLists from './savedLists'
import savedListsNotification from './savedListsNotification'
import settings from './settings'
import history from './history'
import keyList from './keyList'

export default combineReducers({
    lines,
    linesIds,
    title,
    dropBox,
    tags,
    tagsIds,
    tagColors,
    openComments,
    notificCommentIds,
    favicon,
    userName,
    user,
    filterTagIds,
    commentsTime,
    rangy,
    savedLists,
    savedListsNotification,
    settings,
    history,
    keyList,
    routing: routerReducer
})  


// WEBPACK FOOTER //
// ./src/reducers/index.js